import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import {
  stateWithheld,
  w2Year,
} from "../../../../../../assets/data/projectData";
import { useDispatch, useSelector } from "react-redux";
import { updateEmployeeStart } from "../../../../../../redux/slices/employee/employeeSlice";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { v4 as uuidv4 } from "uuid";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addW4FormDocumentsStart, getAllTaxFormDocumentsStart } from "../../../../../../redux/slices/document/documentSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
const W2Modal = ({ isOpen, onClose, edit }) => {
  const dispatch = useDispatch();
  const { employeeProfileUiid } = useSelector((state) => state.employee);
  const [validationRules, setValidationRules] = useState({});
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const initialFormData = {
    w2Year: "",
    stateWithheld: "",
    w2Amount: "",
    attachments: [],
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  useEffect(() => {
    const baseRules = {
      w2Year: { type: "select", required: true },
      stateWithheld: { type: "select", required: true },
      w2Amount: { type: "text", required: true, number: true },
      attachments: {
        type: "file",
        required: true,
        // allowedFiles: [{ ext: "txt", mime: "text/plain" }],
      },
    };
    setValidationRules(baseRules);
  }, [formData.attachments.length]);
  const handleSaveW2Form = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const userFormData = {
        taxType:2,
         addedBy: loginUserUiid,
    employeeId:employeeProfileUiid,
        year: formData.w2Year,
        stateWithheld: formData.stateWithheld,
        amount: formData.w2Amount,
      };
      const submissionData = filterEmptyValues(userFormData);
      // Prepare attachments with UUID
      const cleanAttachments = Array.isArray(formData.attachments)
        ? formData.attachments.map((file) => {
            file.id = uuidv4();
            return file;
          })
        : [];
      if (cleanAttachments.length > 0) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            uiid: employeeProfileUiid,
            entity: "emptaxforms",
            category: "w4form",
            coll: "EmpTaxform",
            doc: cleanAttachments,
            onSuccess: async (fileData) => {
              dispatch(
                addW4FormDocumentsStart({
                  coll: "EmpTaxform",
                  payload: submissionData,
                  onSuccess: async (response) => {
                    const taxFormId = response?.data?.data?.taxformId;
                    if (!taxFormId) return;
                    dispatch(
                      addDocumentStart({
                        coll: "Document",
                        refColl: "EmpTaxform",
                        refId: taxFormId,
                        refField: "documents",
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                         parent:{employee:employeeProfileUiid},
                              addedBy: loginUserUiid,
                              docType: "W4Form",
                              ref: {
                                id: taxFormId,
                                entity: "documents",
                                path: `documents`,
                              },
                              file: cleanAttachments.map((obj) => ({
                                name: obj.attachmentName,
                                comments: obj.attachmentComments,
                                keys: fileData
                                  .filter(
                                    (file) =>
                                      file?.fileRefId === obj.id && file.key
                                  )
                                  .map((file) => file.key),
                              })),
                            },
                          ],
                        },
                        onSuccess: async () => {
                          onClose();
                          dispatch(
                            getAllTaxFormDocumentsStart({
                              tab: "w4FormTab",
                              ret: "w2Form",
                              coll: "EmpTaxform",
                              fil: {
                                employeeId: {
                                  type: "NONE",
                                  value: employeeProfileUiid,
                                },
                                taxType: {
                                  type: "NONE",
                                  value: 2,
                                },
                              },
                              ref: "Document",
                            })
                          );
                        },
                      })
                    );
                  },
                })
              );
            },
          })
        );
      }

      //console.log("Saved Form Data :", formData);
    } else {
      // console.log("form errors :", errors);
      showToast("Please fill all the required fields before saving", "error");
    }
  };

  const handleModalClose = () => {
    onClose(true);
    setFormData(initialFormData);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleModalClose} title="ADD  W-2 FORM">
      <div className="grid grid-cols-1 gap-y-6">
        <FormFieldSet
          type="select"
          title="W-2 Year"
          placeholder="Select W-2 Year"
          value={formData.w2Year}
          onChange={(value) => handleChange("w2Year", value)}
          error={errors.w2Year}
          options={w2Year}
        />
        <FormFieldSet
          type="select"
          title="State Withheld"
          placeholder="Select State Withheld"
          value={formData.stateWithheld}
          onChange={(value) => handleChange("stateWithheld", value)}
          error={errors.stateWithheld}
          options={stateWithheld}
        />
        <FormFieldSet
          type="text"
          title="W-2 Amount"
          placeholder="Enter W-2 Amount"
          value={formData.w2Amount}
          onChange={(value) => handleChange("w2Amount", value)}
          error={errors.w2Amount}
        />
        <FormFieldSet
          type="file"
          title="Attachments"
          placeholder="Choose file"
          value={formData.attachments}
          onChange={(value) => handleChange("attachments", value)}
          error={errors.attachments}
          multiple
        />
      </div>
      <div className="flex gap-3 justify-end mt-14">
        <Button
          title={"cancel"}
          variant="outlined"
          onClick={handleModalClose}
        />
        <Button title={"Save"} onClick={handleSaveW2Form} />
      </div>
    </Modal>
  );
};

export default W2Modal;
